const _ = require("lodash");
const engb = require("./en-gb.json");
const idid = require("./id-id.json");
const thth = require("./th-th.json");
const vivn = require("./vi-vn.json");
const kmkh = require("./km-kh.json");
const jajp = require("./ja-jp.json");
const kokr = require("./ko-kr.json");



const getStationDetails_local = (lang, code) => {
    let file = engb;
    switch (lang) {
        case 'th-th':
            file = thth;
            break;
        case 'id-id':
            file = idid;
            break;
        case 'vi-vn':
            file = vivn;
            break;
        case 'km-kh':
            file = kmkh;
            break;
        case 'ja-jp':
            file = jajp;
            break;
        case 'ko-kr':
            file = kokr;
            break;
        default:
            break;
    }
    // const file = lang === 'th-th' ? thth : lang === 'id-id' ? idid : engb;
    return _.get(file, _.upperCase(_.trim(code)), {})
}

module.exports.getStationDetails_local = getStationDetails_local;